module.exports = __webpack_public_path__ + "media/images/iconSocialShare__errorRed--dark-ae2f5c2899cbb744cff5f02cd5667270.png";